import React, { useState, useRef, useEffect } from 'react';

const LazyImage = ({ 
  src, 
  alt, 
  className = '', 
  style = {}, 
  loading = 'lazy', 
  placeholder = true,
  priority = false,
  ...props 
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef();

  // For images above the fold or marked as priority, load immediately
  const shouldLoadEager = priority || loading === 'eager';

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const handleError = () => {
    setHasError(true);
    setIsLoaded(true);
  };

  // Placeholder styles
  const placeholderStyle = {
    backgroundColor: '#f0f0f0',
    backgroundImage: 'linear-gradient(45deg, transparent 25%, rgba(255,255,255,0.5) 25%, rgba(255,255,255,0.5) 75%, transparent 75%)',
    backgroundSize: '20px 20px',
    animation: 'shimmer 1.5s infinite linear',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
    fontSize: '14px',
    minHeight: '100px',
    ...style
  };

  if (hasError) {
    return (
      <div 
        className={`lazy-image-error ${className}`}
        style={{
          ...placeholderStyle,
          backgroundColor: '#f5f5f5',
          backgroundImage: 'none'
        }}
        {...props}
      >
        <span>Image unavailable</span>
      </div>
    );
  }

  return (
    <>
      {/* Add shimmer animation CSS if not already present */}
      <style>{`
        @keyframes shimmer {
          0% { background-position: -20px 0; }
          100% { background-position: 40px 0; }
        }
      `}</style>
      
      {placeholder && !isLoaded && (
        <div 
          className={`lazy-image-placeholder ${className}`}
          style={placeholderStyle}
          {...props}
        >
          <span>Loading...</span>
        </div>
      )}
      
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={`lazy-image ${className} ${!isLoaded && placeholder ? 'opacity-0 absolute' : ''}`}
        style={{
          ...style,
          ...(isLoaded ? {} : placeholder ? { position: 'absolute', opacity: 0 } : {})
        }}
        loading={shouldLoadEager ? 'eager' : 'lazy'}
        onLoad={handleLoad}
        onError={handleError}
        {...props}
      />
    </>
  );
};

export default LazyImage;